<template>
    <div style="background-color: #10418b;height: 100%">
    <div id="table-box">
        <van-row justify="center">
<!--            <van-col span="6">-->
                <van-image
                    width="100%"
                    height="100%"
                    src="https://afa.activa-leisure.com/img/bg.jpg"
                />
<!--            </van-col>-->
        </van-row>
        <van-col span="20"></van-col>
        <van-popup  v-model:show="showPicker1" round position="bottom">
            <van-search
                v-model="searchValue1"
                show-action
                placeholder="支持模糊搜索 工号/姓名/职务/部门"
                background="#0f86d0"
            >
                <template #action>
                    <div @click="onSearch1">搜索</div>
                </template>
            </van-search>
            <van-picker
                v-model="picker1"
                :columns="columns1"
                @cancel="showPicker1 = false"
                @confirm="onConfirm1"
                :title="customFieldTitle"
                :columns-field-names="customFieldName"
            />
        </van-popup>
        <van-popup v-model:show="showPicker2" round position="bottom">
            <van-search
                v-model="searchValue2"
                show-action
                placeholder="支持模糊搜索 工号/姓名/职务/部门"
                background="#0f86d0"
            >
                <template #action>
                    <div @click="onSearch2">搜索</div>
                </template>
            </van-search>
            <van-picker
                v-model="picker2"
                :columns="columns1"
                @cancel="showPicker2 = false"
                @confirm="onConfirm2"
                :title="customFieldTitle"
                :columns-field-names="customFieldName"
            />
        </van-popup>
        <van-popup v-model:show="showPicker3" round position="bottom">
            <van-search
                v-model="searchValue3"
                show-action
                placeholder="支持模糊搜索 工号/姓名/职务/部门"
                background="#0f86d0"
            >
                <template #action>
                    <div @click="onSearch3">搜索</div>
                </template>
            </van-search>
            <van-picker
                v-model="picker3"
                :columns="columns1"
                @cancel="showPicker3 = false"
                @confirm="onConfirm3"
                :title="customFieldTitle"
                :columns-field-names="customFieldName"
            />
        </van-popup>
        <van-popup v-model:show="showPicker4" round position="bottom">
            <van-search
                v-model="searchValue4"
                show-action
                placeholder="支持模糊搜索 工号/姓名/职务/部门"
                background="#0f86d0"
            >
                <template #action>
                    <div @click="onSearch4">搜索</div>
                </template>
            </van-search>
            <van-picker
                v-model="picker4"
                :columns="columns1"
                @cancel="showPicker4 = false"
                @confirm="onConfirm4"
                :title="customFieldTitle"
                :columns-field-names="customFieldName"
            />
        </van-popup>
        <van-popup v-model:show="showPicker5" round position="bottom">
            <van-search
                v-model="searchValue5"
                show-action
                placeholder="支持模糊搜索 工号/姓名/职务/部门"
                background="#0f86d0"
            >
                <template #action>
                    <div @click="onSearch5">搜索</div>
                </template>
            </van-search>
            <van-picker
                v-model="picker5"
                :columns="columns1"
                @cancel="showPicker5 = false"
                @confirm="onConfirm5"
                :title="customFieldTitle"
                :columns-field-names="customFieldName"
            />
        </van-popup>
    </div>
    <van-form @submit="onSubmit">
        <van-field
            v-model="workNo"
            required
            label="工号"
            placeholder="请输入工号"
            @blur="getReviewUser"
            :rules="[{ required: true, message: '请输入工号' }]"
        />
        <van-field
            v-model="code"
            required
            label="验证码"
            placeholder="请输入身份证号码后六位"
            :rules="[{ required: true, message: '请输入身份证号码后六位' }]"
        />
        <van-field
            v-model="name"
            readonly
            label="姓名"
            placeholder="输入工号之后，自动获取姓名"
        />
        <van-field
            v-model="dept"
            readonly
            label="部门"
            placeholder="输入工号之后，自动获取部门"
        />
        <!--        <van-field
                    v-model="work"
                    required
                    label="职务"
                    placeholder="请输入职务"
                />-->
        <div v-show="isDivVisible1" >
            <van-row justify="center" >
                <van-col span="20">
                    <h4 style="color: white">{{question1}}</h4>
                </van-col>
                <van-col span="12" style="color: white">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;姓名
                </van-col>
                <van-col span="12" style="color: white">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;原因说明
                </van-col>
            </van-row>
            <div class="form-fields" style="margin-top: 10px;">
                <van-field
                    v-model="name1"
                    is-link
                    readonly
                    placeholder="姓名"
                    @click="showPicker1 = true"
                    class="two-part"
                    :rules = "rules11"
                />
                <van-field
                    v-model="msg1"
                    name="msg1"
                    input-align="left"
                    class="eight-part"
                    placeholder="请输入原因"
                    :rules = "rules12"
                />
                <van-field
                    v-model="name2"
                    is-link
                    readonly
                    placeholder="姓名"
                    @click="showPicker2 = true"
                    class="two-part"
                    :rules = "rules11"
                />
                <van-field
                    v-model="msg2"
                    name="msg2"
                    input-align="left"
                    class="eight-part"
                    placeholder="请输入原因"
                    :rules = "rules12"
                />
                <van-field
                    v-model="name3"
                    is-link
                    readonly
                    placeholder="姓名"
                    @click="showPicker3 = true"
                    class="two-part"
                    :rules = "rules11"
                />
                <van-field
                    v-model="msg3"
                    name="msg3"
                    input-align="left"
                    class="eight-part"
                    placeholder="请输入原因"
                    :rules = "rules12"
                />
                <van-field
                    v-model="name4"
                    is-link
                    readonly
                    placeholder="姓名"
                    @click="showPicker4 = true"
                    class="two-part"
                />
                <van-field
                    v-model="msg4"
                    name="msg4"
                    input-align="left"
                    class="eight-part"
                    placeholder="请输入原因"
                />
                <van-field
                    v-model="name5"
                    is-link
                    readonly
                    placeholder="姓名"
                    @click="showPicker5 = true"
                    class="two-part"
                />
                <van-field
                    v-model="msg5"
                    name="msg5"
                    input-align="left"
                    class="eight-part"
                    placeholder="请输入原因"
                />
            </div>
        </div>
        <div v-show="isDivVisible2">
            <van-row justify="center">
                <van-col span="20">
                    <h4 style="color: white">{{question2}}</h4>
                </van-col>
                <van-col span="12" style="color: white">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;姓名
                </van-col>
                <van-col span="12" style="color: white">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;原因说明
                </van-col>
            </van-row>
            <div class="form-fields" style="margin-top: 10px;">
                <van-popup v-model:show="showPicker6" round position="bottom">
                    <van-search
                        v-model="searchValue6"
                        show-action
                        placeholder="支持模糊搜索 工号/姓名/职务/部门"
                background="#0f86d0"
                    >
                        <template #action>
                            <div @click="onSearch6">搜索</div>
                        </template>
                    </van-search>
                    <van-picker
                        v-model="picker6"
                        :columns="columns1"
                        @cancel="showPicker6 = false"
                        @confirm="onConfirm6"
                        :title="customFieldTitle"
                        :columns-field-names="customFieldName"
                    />
                </van-popup>
                <van-popup v-model:show="showPicker7" round position="bottom">
                    <van-search
                        v-model="searchValue7"
                        show-action
                        placeholder="支持模糊搜索 工号/姓名/职务/部门"
                background="#0f86d0"
                    >
                        <template #action>
                            <div @click="onSearch7">搜索</div>
                        </template>
                    </van-search>
                    <van-picker
                        v-model="picker7"
                        :columns="columns1"
                        @cancel="showPicker7 = false"
                        @confirm="onConfirm7"
                        :title="customFieldTitle"
                        :columns-field-names="customFieldName"
                    />
                </van-popup>
                <van-popup v-model:show="showPicker8" round position="bottom">
                    <van-search
                        v-model="searchValue8"
                        show-action
                        placeholder="支持模糊搜索 工号/姓名/职务/部门"
                background="#0f86d0"
                    >
                        <template #action>
                            <div @click="onSearch8">搜索</div>
                        </template>
                    </van-search>
                    <van-picker
                        v-model="picker8"
                        :columns="columns1"
                        @cancel="showPicker8 = false"
                        @confirm="onConfirm8"
                        :title="customFieldTitle"
                        :columns-field-names="customFieldName"
                    />
                </van-popup>
                <van-popup v-model:show="showPicker9" round position="bottom">
                    <van-search
                        v-model="searchValue9"
                        show-action
                        placeholder="支持模糊搜索 工号/姓名/职务/部门"
                background="#0f86d0"
                    >
                        <template #action>
                            <div @click="onSearch9">搜索</div>
                        </template>
                    </van-search>
                    <van-picker
                        v-model="picker9"
                        :columns="columns1"
                        @cancel="showPicker9 = false"
                        @confirm="onConfirm9"
                        :title="customFieldTitle"
                        :columns-field-names="customFieldName"
                    />
                </van-popup>
                <van-popup v-model:show="showPicker10" round position="bottom">
                    <van-search
                        v-model="searchValue10"
                        show-action
                        placeholder="支持模糊搜索 工号/姓名/职务/部门"
                background="#0f86d0"
                    >
                        <template #action>
                            <div @click="onSearch10">搜索</div>
                        </template>
                    </van-search>
                    <van-picker
                        v-model="picker10"
                        :columns="columns1"
                        @cancel="showPicker10 = false"
                        @confirm="onConfirm10"
                        :title="customFieldTitle"
                        :columns-field-names="customFieldName"
                    />
                </van-popup>

                <van-field
                    v-model="name6"
                    is-link
                    readonly
                    placeholder="姓名"
                    @click="showPicker6 = true"
                    class="two-part"
                    :rules = "rules21"
                />
                <van-field
                    v-model="msg6"
                    name="msg6"
                    input-align="left"
                    class="eight-part"
                    placeholder="请输入原因"
                    :rules = "rules22"
                />
                <van-field
                    v-model="name7"
                    is-link
                    readonly
                    placeholder="姓名"
                    @click="showPicker7 = true"
                    class="two-part"
                    :rules = "rules21"
                />
                <van-field
                    v-model="msg7"
                    name="msg7"
                    input-align="left"
                    class="eight-part"
                    placeholder="请输入原因"
                    :rules = "rules22"
                />
                <van-field
                    v-model="name8"
                    is-link
                    readonly
                    placeholder="姓名"
                    @click="showPicker8 = true"
                    class="two-part"
                    :rules = "rules21"
                />
                <van-field
                    v-model="msg8"
                    name="msg8"
                    input-align="left"
                    class="eight-part"
                    placeholder="请输入原因"
                    :rules = "rules22"
                />
                <van-field
                    v-model="name9"
                    is-link
                    readonly
                    placeholder="姓名"
                    @click="showPicker9 = true"
                    class="two-part"
                />
                <van-field
                    v-model="msg9"
                    name="msg9"
                    input-align="left"
                    class="eight-part"
                    placeholder="请输入原因"
                />
                <van-field
                    v-model="name10"
                    is-link
                    readonly
                    placeholder="姓名"
                    @click="showPicker10 = true"
                    class="two-part"
                />
                <van-field
                    v-model="msg10"
                    name="msg10"
                    input-align="left"
                    class="eight-part"
                    placeholder="请输入原因"
                />
            </div>
        </div>
        <div v-show="isDivVisible3">
            <van-row justify="center">
                <van-col span="20">
                    <h4 style="color: white">{{question3}}</h4>
                </van-col>
            </van-row>
            <div class="form-fields">
                <van-field
                    v-model="msg11"
                    name="msg11"
                    input-align="left"
                    placeholder="请输入建议"
                    :rules = "rules3"
                />
                <van-field
                    v-model="msg12"
                    name="msg12"
                    input-align="left"
                    placeholder="请输入建议"
                    :rules = "rules3"
                />
                <van-field
                    v-model="msg13"
                    name="msg13"
                    input-align="left"
                    placeholder="请输入建议"
                    :rules = "rules3"
                />
                <van-field
                    v-model="msg14"
                    name="msg14"
                    input-align="left"
                    placeholder="请输入建议"
                />
                <van-field
                    v-model="msg15"
                    name="msg15"
                    input-align="left"
                    placeholder="请输入建议"
                />
            </div>
        </div>
        <div v-show="isDivVisible4" >
            <van-row justify="center">
                <van-col span="20">
                    <h4 style="color: white">{{question4}}</h4>
                </van-col>
            </van-row>
            <div class="form-fields">

                <van-field
                    v-model="msg16"
                    name="msg16"
                    input-align="left"
                    placeholder="请输入建议"
                    :rules = "rules4"
                />

                <van-field
                    v-model="msg17"
                    name="msg17"
                    input-align="left"
                    placeholder="请输入建议"
                    :rules = "rules4"
                />

                <van-field
                    v-model="msg18"
                    name="msg18"
                    input-align="left"
                    placeholder="请输入建议"
                    :rules = "rules4"
                />

                <van-field
                    v-model="msg19"
                    name="msg19"
                    input-align="left"
                    placeholder="请输入建议"
                />

                <van-field
                    v-model="msg20"
                    name="msg20"
                    input-align="left"
                    placeholder="请输入建议"
                />
            </div>
        </div>
        <div style="margin: 16px;" >
            <van-button round block type="success" native-type="submit" style="font-size: larger">
                提&nbsp;&nbsp;交
            </van-button>
        </div>
        <div style="margin-right: 16px;margin-left: 16px;margin-top: 16px;">
            <van-button round block type="primary" @click="select" style="font-size: larger">
                查&nbsp;&nbsp;询
            </van-button>
        </div>
    </van-form>
    </div>
</template>

<script setup>

import {onMounted, ref} from "vue";
import axios from "axios";
import { showDialog} from "vant";

const workNo = ref('');
const code = ref('');
const name = ref('');
const dept = ref('');

const workNo1 = ref('');
const name1 = ref('');
const msg1 = ref('');
const workNo2 = ref('');
const name2 = ref('');
const msg2 = ref('');
const workNo3 = ref('');
const name3 = ref('');
const msg3 = ref('');
const workNo4 = ref('');
const name4 = ref('');
const msg4 = ref('');
const workNo5 = ref('');
const name5 = ref('');
const msg5 = ref('');
const workNo6 = ref('');
const name6 = ref('');
const msg6 = ref('');
const workNo7 = ref('');
const name7 = ref('');
const msg7 = ref('');
const workNo8 = ref('');
const name8 = ref('');
const msg8 = ref('');
const workNo9 = ref('');
const name9 = ref('');
const msg9 = ref('');
const workNo10 = ref('');
const name10 = ref('');
const msg10 = ref('');
const msg11 = ref('');
const msg12 = ref('');
const msg13 = ref('');
const msg14 = ref('');
const msg15 = ref('');
const msg16 = ref('');
const msg17 = ref('');
const msg18 = ref('');
const msg19 = ref('');
const msg20 = ref('');

const customFieldTitle = "工号\u3000姓名\u3000职级\u3000部门";

const customFieldName = {
    text: 'user',
    value: 'name',
};

let columns1 = [
    { user:'139533\u3000曹操\u3000魏国',workNo: '139533',name: '曹操', dept: '魏国' },
    { user:'139532\u3000曹丕\u3000魏国',workNo: '139532',name: '曹丕', dept: '魏国' },
    { user:'139539\u3000刘备\u3000蜀国',workNo: '139539',name: '刘备', dept: '蜀国' },
    { user:'139531\u3000刘禅\u3000蜀国',workNo: '139531',name: '刘禅', dept: '蜀国' },
    { user:'139541\u3000孙权\u3000吴国',workNo: '139541',name: '孙权', dept: '吴国' },
    { user:'239541\u3000孙策\u3000吴国',workNo: '239541',name: '孙策', dept: '吴国' },
];
const showPicker1 = ref(false);
const showPicker2 = ref(false);
const showPicker3 = ref(false);
const showPicker4 = ref(false);
const showPicker5 = ref(false);
const showPicker6 = ref(false);
const showPicker7 = ref(false);
const showPicker8 = ref(false);
const showPicker9 = ref(false);
const showPicker10 = ref(false);

const searchValue1 = ref('');
const searchValue2 = ref('');
const searchValue3 = ref('');
const searchValue4 = ref('');
const searchValue5 = ref('');
const searchValue6 = ref('');
const searchValue7 = ref('');
const searchValue8 = ref('');
const searchValue9 = ref('');
const searchValue10 = ref('');
let picker1 = ref(['']);//为了实现进来选中第二个
let picker2 = ref(['']);
let picker3 = ref(['']);
let picker4 = ref(['']);
let picker5 = ref(['']);
let picker6 = ref(['']);
let picker7 = ref(['']);
let picker8 = ref(['']);
let picker9 = ref(['']);
let picker10 = ref(['']);

let rules11 = ref('');
let rules12 = ref('');
let rules21 = ref('');
let rules22 = ref('');
let rules3 = ref('');
let rules4 = ref('');


const onSearch1 = () => {
    const matchedItem = columns1.find(item => item.user.includes(searchValue1.value));
    if (matchedItem){
        picker1.value=[matchedItem.name];
    }

}
const onSearch2 = () => {
    const matchedItem = columns1.find(item => item.user.includes(searchValue2.value));
    if (matchedItem){
        picker2.value=[matchedItem.name];
    }
}
const onSearch3 = () => {
    const matchedItem = columns1.find(item => item.user.includes(searchValue3.value));
    if (matchedItem){
        picker3.value=[matchedItem.name];
    }
}
const onSearch4 = () => {
    const matchedItem = columns1.find(item => item.user.includes(searchValue4.value));
    if (matchedItem){
        picker4.value=[matchedItem.name];
    }
}
const onSearch5 = () => {
    const matchedItem = columns1.find(item => item.user.includes(searchValue5.value));
    if (matchedItem){
        picker5.value=[matchedItem.name];
    }
}
const onSearch6 = () => {
    const matchedItem = columns1.find(item => item.user.includes(searchValue6.value));
    if (matchedItem){
        picker6.value=[matchedItem.name];
    }
}
const onSearch7 = () => {
    const matchedItem = columns1.find(item => item.user.includes(searchValue7.value));
    if (matchedItem){
        picker7.value=[matchedItem.name];
    }
}
const onSearch8 = () => {
    const matchedItem = columns1.find(item => item.user.includes(searchValue8.value));
    if (matchedItem){
        picker8.value=[matchedItem.name];
    }

}
const onSearch9 = () => {
    const matchedItem = columns1.find(item => item.user.includes(searchValue9.value));
    if (matchedItem){
        picker9.value=[matchedItem.name];
    }
}
const onSearch10 = () => {
    const matchedItem = columns1.find(item => item.user.includes(searchValue10.value));
    if (matchedItem){
        picker10.value=[matchedItem.name];
    }
}
const onConfirm1 = ({ selectedOptions }) => {
    console.log("选择的值为"+picker1.value);
    showPicker1.value = false;
    name1.value = selectedOptions[0].name;
    workNo1.value = selectedOptions[0].workNo;
};
const onConfirm2 = ({ selectedOptions }) => {
    showPicker2.value = false;
    name2.value = selectedOptions[0].name;
    workNo2.value = selectedOptions[0].workNo;
};
const onConfirm3 = ({ selectedOptions }) => {
    showPicker3.value = false;
    name3.value = selectedOptions[0].name;
    workNo3.value = selectedOptions[0].workNo;
};
const onConfirm4 = ({ selectedOptions }) => {
    showPicker4.value = false;
    name4.value = selectedOptions[0].name;
    workNo4.value = selectedOptions[0].workNo;
};
const onConfirm5 = ({ selectedOptions }) => {
    showPicker5.value = false;
    name5.value = selectedOptions[0].name;
    workNo5.value = selectedOptions[0].workNo;
};
const onConfirm6 = ({ selectedOptions }) => {
    showPicker6.value = false;
    name6.value = selectedOptions[0].name;
    workNo6.value = selectedOptions[0].workNo;
};
const onConfirm7 = ({ selectedOptions }) => {
    showPicker7.value = false;
    name7.value = selectedOptions[0].name;
    workNo7.value = selectedOptions[0].workNo;
};
const onConfirm8 = ({ selectedOptions }) => {
    showPicker8.value = false;
    name8.value = selectedOptions[0].name;
    workNo8.value = selectedOptions[0].workNo;
};
const onConfirm9 = ({ selectedOptions }) => {
    showPicker9.value = false;
    name9.value = selectedOptions[0].name;
    workNo9.value = selectedOptions[0].workNo;
};
const onConfirm10 = ({ selectedOptions }) => {
    showPicker10.value = false;
    name10.value = selectedOptions[0].name;
    workNo10.value = selectedOptions[0].workNo;
};

const isDivVisible1 = ref(false);
const isDivVisible2 = ref(false);
const isDivVisible3 = ref(false);
const isDivVisible4 = ref(false);
const question1 = ref("初始问题1");
const question2 = ref("初始问题1");
const question3 = ref("初始问题1");
const question4 = ref("初始问题1");
let questions = [];

const select = () => {
    if (workNo.value === ""){
        alert("请填写工号")
        return;
    }
    if (code.value === ""){
        alert("请填写验证码")
        return
    }

    const formData = {
        workNo:workNo.value,
        code:code.value,
        company:'qd'
    }


    axios.post(process.env.VUE_APP_API_BASE_URL + '/lj/mzpx/select', formData,{
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => {
            if(response.data.success){
                console.log('提交成功:', response.data)
                // 在这里可以根据后台返回的数据进行相应的处理
                alert("查询成功！")
                workNo.value = response.data.data.workNo;
                code.value = response.data.data.code;
                name.value = response.data.data.name;
                dept.value = response.data.data.dept;
                workNo1.value = response.data.data.workNo1;
                name1.value = response.data.data.name1;
                msg1.value = response.data.data.msg1;
                workNo2.value = response.data.data.workNo2;
                name2.value = response.data.data.name2;
                msg2.value = response.data.data.msg2;
                workNo3.value = response.data.data.workNo3;
                name3.value = response.data.data.name3;
                msg3.value = response.data.data.msg3;
                workNo4.value = response.data.data.workNo4;
                name4.value = response.data.data.name4;
                msg4.value = response.data.data.msg4;
                workNo5.value = response.data.data.workNo5;
                name5.value = response.data.data.name5;
                msg5.value = response.data.data.msg5;
                workNo6.value = response.data.data.workNo6;
                name6.value = response.data.data.name6;
                msg6.value = response.data.data.msg6;
                workNo7.value = response.data.data.workNo7;
                name7.value = response.data.data.name7;
                msg7.value = response.data.data.msg7;
                workNo8.value = response.data.data.workNo8;
                name8.value = response.data.data.name8;
                msg8.value = response.data.data.msg8;
                workNo9.value = response.data.data.workNo9;
                name9.value = response.data.data.name9;
                msg9.value = response.data.data.msg9;
                workNo10.value = response.data.data.workNo10;
                name10.value = response.data.data.name10;
                msg10.value = response.data.data.msg10;
                msg11.value = response.data.data.msg11;
                msg12.value = response.data.data.msg12;
                msg13.value = response.data.data.msg13;
                msg14.value = response.data.data.msg14;
                msg15.value = response.data.data.msg15;
                msg16.value = response.data.data.msg16;
                msg17.value = response.data.data.msg17;
                msg18.value = response.data.data.msg18;
                msg19.value = response.data.data.msg19;
                msg20.value = response.data.data.msg20;
            }else {
                alert(response.data.message)
            }


        })
        .catch(error => {
            if (error.response) {
                // 请求已经发出，但服务器返回状态码不在2xx范围内
                console.error('返回失败:', error.response.const)
            } else {
                // 请求未能发出
                alert('提交失败:' + error.message)
                console.error('提交失败:', error.message)
            }
        })
}

const onSubmit = () => {


    const formData = {
        workNo:workNo.value,
        code:code.value,
        name:name.value,
        dept:dept.value,
        workNo1:workNo1.value,
        name1:name1.value,
        msg1:msg1.value,
        workNo2:workNo2.value,
        name2:name2.value,
        msg2:msg2.value,
        workNo3:workNo3.value,
        name3:name3.value,
        msg3:msg3.value,
        workNo4:workNo4.value,
        name4:name4.value,
        msg4:msg4.value,
        workNo5:workNo5.value,
        name5:name5.value,
        msg5:msg5.value,
        workNo6:workNo6.value,
        name6:name6.value,
        msg6:msg6.value,
        workNo7:workNo7.value,
        name7:name7.value,
        msg7:msg7.value,
        workNo8:workNo8.value,
        name8:name8.value,
        msg8:msg8.value,
        workNo9:workNo9.value,
        name9:name9.value,
        msg9:msg9.value,
        workNo10:workNo10.value,
        name10:name10.value,
        msg10:msg10.value,
        msg11:msg11.value,
        msg12:msg12.value,
        msg13:msg13.value,
        msg14:msg14.value,
        msg15:msg15.value,
        msg16:msg16.value,
        msg17:msg17.value,
        msg18:msg18.value,
        msg19:msg19.value,
        msg20:msg20.value
    }

    axios.post(process.env.VUE_APP_API_BASE_URL + '/lj/mzpx/submit', formData,{
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => {
            console.log('提交成功:', response.data)
            // 在这里可以根据后台返回的数据进行相应的处理
            alert(response.data.message)
        })
        .catch(error => {
            if (error.response) {
                // 请求已经发出，但服务器返回状态码不在2xx范围内
                console.error('返回失败:', error.response.const)
            } else {
                // 请求未能发出
                alert('提交失败:' + error.message)
                console.error('提交失败:', error.message)
            }
        })

    // 处理第一个表单的提交
}

function getReviewUser(){
    console.log("开始查询工号："+workNo.value)
    if(workNo.value.length===6 || workNo.value.length===9){
       axios.get(process.env.VUE_APP_API_BASE_URL+"/lj/mzpx/getUser?workNo="+workNo.value+"&company=qd").then(result =>{
           console.log(result);
           if(result.data.success){
               name.value = result.data.reviewUser.name;
               dept.value = result.data.reviewUser.dept;
           }else {
               workNo.value = "";
               name.value = "";
               dept.value = "";
               alert(result.data.message);
           }
       })

    }else {
        alert("请输入正确的工号");
        workNo.value = "";
        name.value = "";
        dept.value = "";
    }
}

onMounted(() => {
    /*window.document.title = '2024年宁波万汇干部年会民主评议'*/
    axios.get(process.env.VUE_APP_API_BASE_URL+"/lj/mzpx/questionlist/qd",
        {},
        {
            headers:{
                "content-type": "application/x-www-form-urlencoded"
            }
        }
    ).then( result =>{
        //closeToast();
        if (result.data.success){
            questions = result.data.date;
            //console.log("questions.value："+questions.value);
            // 使用for循环遍历数组
            for (let i = 0; i < questions.length; i++) {
                let question = questions[i];
                if (question.sort === 0){
                    window.document.title = question.question;
                }
                if (question.sort === 1){
                    isDivVisible1.value = true;
                    question1.value =(i)+'.'+question.question;
                    rules11.value = [{ required: true, message: '请输入姓名' }];
                    rules12.value = [{ required: true, message: '请输入原因' }];
                }
                if (question.sort === 2){
                    isDivVisible2.value = true;
                    question2.value = (i)+'.'+question.question;
                    rules21.value = [{ required: true, message: '请输入姓名' }];
                    rules22.value = [{ required: true, message: '请输入原因' }];

                }
                if (question.sort === 3){
                    isDivVisible3.value = true;
                    question3.value = (i)+'.'+question.question;
                    rules3 = [{ required: true, message: '请输入建议' }];
                }
                if (question.sort === 4){
                    isDivVisible4.value = true;
                    question4.value = (i)+'.'+question.question;
                    rules4 = [{ required: true, message: '请输入建议' }];
                }
            }
        }else {
            console.log(result.data.message)
            showDialog({
                title: '错误提示',
                message: result.data.message,
                theme: 'round-button',
                showConfirmButton:false,
            }).then(() => {
                // on close
            });
        }
        console.log(result);
    })
    axios.get(process.env.VUE_APP_API_BASE_URL+"/lj/mzpx/userList/qd",
        {},
        {
            headers:{
                "content-type": "application/x-www-form-urlencoded"
            }
        }
    ).then( result =>{
        //closeToast();
        if (result.data.success){
            columns1 = result.data.reviewUserList;
        }else {
            alert("网络错误，请联系管理员")
        }
        console.log(result);
    })
})
</script>

<style scoped>
.form-fields {
    display: flex;
    flex-wrap: wrap; /* 允许元素换行（尽管在这个例子中可能不需要）*/
    justify-content: space-between; /* 水平方向上的对齐方式 */
}

.form-fields > .two-part {
    flex: 0 0 calc(30% - 0px); /* 占据20%的宽度（减去一些间距），不伸缩，不放大 */
    margin-bottom: 5px; /* 垂直间距 */
}

.form-fields > .eight-part {
    flex: 0 0 calc(70% - 5px); /* 占据80%的宽度（减去一些间距），不伸缩，不放大 */
    margin-bottom: 5px; /* 垂直间距 */
}
</style>
